{
  "dates-and-configuration": "Dates & Configuration",
  "type": "Type",
  "transaction-types": "Transaction Types",
  "closing-date": "Closing Date",
  "acceptance-date": "Acceptance Date",
  "estimated-closing-date": "Estimated Closing Day",
  "founding-date": "Funding Date",
  "contract-date": "Contract Date",
  "disbursement-date": "Disbursement Date",
  "amounts": "Amounts",
  "purchase-prices": "Purchase Prices",
  "loan-amounts": "Loan Amounts",
  "purchase-price": "Total Purchase Price",
  "load-amount": "Total Loan Amount",
  "heloc": "Heloc",
  "place-of-closing": "Place of Closing",
  "address": "Address",
  "state": "State",
  "city": "City",
  "county": "County",
  "configuration": "Configuration",
  "workflow": "Workflow",
  "status": "Status",
  "statusHelperText": "Notice: No further updates will be allowed once the status is set to \"Closed\".",
  "addressesTakenFrom": "Addresses taken from: {{name}}",
  "additionalFeesLetter": "Additional Fees Letter",
  "additionalFees": "Additional Fees"
}
